module.exports = __webpack_public_path__ + "media/images/countryrect/ph-661fbf5bd881f693231b7f1e45f1bd1f.svg";